/* eslint-disable */
var $ = window.jQuery = require('jquery');
import toast from '../../services/toast';
import {
  mapGetters
} from 'vuex';
export default {
  name: 'tab-bullets-point',
  components: {},
  props: ['courseTabID'],
  data() {
    return {
      content: '',
      courseTabDetais: {},
      submitted: false,
      removeBulletID: '',
      editBulletID: '',
      TabName: '',
      TabNamelower: '',
      id: '',
      edit_bullet_point: '',
      updateBulletsData: false
    }
  },
  computed: {
    ...mapGetters([
      'getcourseDetailstabByIDState',
      'getBulletDataByIDState',
      'getcourseDetailstabByIDState'
    ]),
    getCourseTabDetails() {
      this.courseTabDetais = this.$store.getters.getcourseDetailstabByIDState.data;
      return this.courseTabDetais
      debugger
    },
    GetTabDeTailsByIDFun() {
      this.$store.dispatch('getCourseTabDetailsByID', {
        id: this.courseTabID
      }).then((res) => {
        this.TabName = this.$store.getters.getcourseDetailstabByIDState.data.data.name
        this.TabNamelower = this.TabName.toLowerCase()
      }).catch((err) => {})
    }
  },
  mounted() {
    this.getCourseTabDetails,
      this.GetTabDeTailsByIDFun
    console.log(this.courseTabDetais, 'BUllets List')
  },
  methods: {
    getCourseDetailsAgain() {
      this.$store.dispatch('getCourseTabDetailsByID', {
        id: this.courseTabID
      }).then((res) => {
        console.log(res.data.data)
      }).catch((err) => {})
    },
    validateCreateBulletBeforeSubmit() {
      this.$validator.validateAll().then((result) => {
        // debugger
        this.submitted = true;
        if (result) {
          let data = {
            content: this.content,
            course_detail_tab: this.courseTabID
          }
          this.$store.dispatch('create_bullets_list', data).then((res) => {
              if (res.status == '201') {
                this.content = '',
                  this.getCourseDetailsAgain();
                // debugger
                toast.success(res.data.msg);
                this.$validator.reset();
              }
            })
            .catch((err) => {
              toast.error("Please Create Tab First");
            })
          return
        }
      });
    },
    removeBUllet(id) {
      $('#removeBulletModal').modal()
      this.removeBulletID = id
    },
    removeBulletConfirmation() {
      debugger
      let data = {
        id: this.removeBulletID
      }
      this.$store.dispatch('remove_bullets_list', data)
        .then((res) => {
          if (res.status == '200' || res.status == '202') {
            toast.success(res.data.msg);
            this.getCourseDetailsAgain();
          }
        })
        .catch((err) => {})
    },
    updateBullet(id) {
      this.editBulletID = id,
        this.updateBulletsData = true
      let data = {
        id: this.editBulletID
      }
      this.$store.dispatch('GetBulletdataByID', data)
        .then((res) => {
          this.edit_bullet_point = this.$store.getters.getBulletDataByIDState.data.content
        })
        .catch((err) => {})
    },
    updateBulletConfirmation() {
      let data = {
        content: this.edit_bullet_point
      }
      this.$store.dispatch('UpdateBulletPointById', {
          data: {
            data: data,
            id: this.editBulletID
          }
        })
        .then((res) => {
          toast.success(res.data.msg);
          this.getCourseDetailsAgain();
          this.updateBulletsData = false
        })
        .catch((err) => {})
    },
    PopupClose() {
      this.updateBulletsData = false
    }
  },
  beforeMount() {
    this.getCourseDetails;
  },
  watch: {
    getCourseTabDetails() {
      return this.$store.getters.getcourseDetailstabByIDState.data
    },
  }
}